module.exports = __webpack_public_path__ + "img/background.3ac97ce1.png";